import React from 'react'
import ReactSelect, { NamedProps as ReactSelectProps, Theme } from 'react-select'

type Styles = Record<string, string>
type Props = { dark?: boolean } & ReactSelectProps<{ value: string; label: string }, true>

const selectStyles = (dark?: boolean) => ({
  container: (styles: Styles) => ({
    ...styles,
    width: '100%',
  }),
  valueContainer: (styles: Styles) => ({
    ...styles,
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (styles: Styles) => ({
    ...styles,
    color: dark ? styles.color : '#272727',
  }),
  placeholder: (styles: Styles) => ({
    ...styles,
    fontSize: '0.875rem',
    'text-transform': 'uppercase',
    color: dark ? '#e9ecef' : '#272727',
  }),
  singleValue: (styles: Styles) => ({
    ...styles,
    fontSize: '0.875rem',
    color: dark ? '#e9ecef' : '#272727',
    'text-transform': 'uppercase',
  }),
  multiValue: (styles: Styles) => ({
    ...styles,
    fontSize: '0.875rem',
    color: dark ? '#e9ecef' : '#272727',
    'text-transform': 'uppercase',
  }),
  control: (styles: Styles) => ({
    ...styles,
    borderColor: dark ? '#525252' : '#dcdcdc',
  }),
  option: (styles: Styles, state: { isSelected: boolean }) => ({
    ...styles,
    backgroundColor: state.isSelected ? '#ced4da' : '#ffffff',
    color: '#272727',
    'text-transform': 'uppercase',
    '&:hover': {
      backgroundColor: state.isSelected ? '#979797' : '#f5f5f7',
    },
  }),
  menu: (styles: Styles) => ({
    ...styles,
    zIndex: 100,
  }),
})

const lightTheme = (theme: Theme) => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    neutral20: '#dcdcdc',
    primary25: '#e9ecef',
    primary50: '#dfdfdf',
    primary: '#dcdcdc',
  },
})

const darkTheme = (theme: Theme) => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    primary: '#dcdcdc',
    neutral0: '#272727',
  },
})

const Select = (props: Props) => {
  return (
    <ReactSelect
      styles={selectStyles(props.dark)}
      theme={props.dark ? darkTheme : lightTheme}
      {...props}
    />
  )
}

export default Select
